module.exports = __webpack_public_path__ + "img/Tanklöschfahrzeug.aa46d805.svg";